import { ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { AfipModel } from 'src/app/core/models/afip.model';
import { GenericPlace } from 'src/app/core/models/generic-place.model';
import { CommerceForm } from 'src/app/core/models/interfaces/forms/commerce.form';
import { OrganismModel } from 'src/app/core/models/organism.model';
import { User } from 'src/app/core/models/user';
import { IdentityService } from 'src/app/core/services/identity.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import { UserService } from 'src/app/core/services/user.services';
import { DialogAfipComponent } from 'src/app/shared/components/dialog-afip/dialog-afip.component';
import { DialogCommerceComponent } from 'src/app/shared/components/dialog-commerce/dialog-commerce.component';
import { finalDotVerificator, validateCuit } from 'src/app/shared/functions/afip.functions';
import { AfipService } from 'src/app/core/services/afip.service';
import { IOptionsNgSelect } from 'src/app/shared/interfaces/ioptionsNgSelect';
import { Router } from '@angular/router';
import { SearchPlaceComponent } from '../my-commerce/components/search-place/search-place.component';

@Component({
  selector: 'app-new-commerce',
  templateUrl: './new-commerce.component.html',
  styleUrls: ['./new-commerce.component.scss']
})
export class NewCommerceComponent implements OnInit {
  private readonly DOMICILIO_COMERCIAL: string = 'domicilioComercial';
  readonly TIPO_CASA: string = 'casa';
  readonly TIPO_DEPARTAMENTO: string = 'departamento';

  @ViewChild(SearchPlaceComponent) searchPlace: SearchPlaceComponent;

  ocult = false;
  checked = false;
  form: UntypedFormGroup;
  currentUser: User;
  rowTxt: number = 1;
  valueToken: string;
  afipData: AfipModel;
  start: boolean = false;
  saving: boolean = false;
  wantToBeOrganismo = false;
  hasApiToken: boolean = false;
  locationData: GenericPlace;
  cuitReadonly: boolean = false;
  isInvalidForm: boolean = false;
  esDepartamento: boolean = false;
  private organism: OrganismModel;
  registryState: RegistryInformation;
  selectHomeType: string = this.TIPO_CASA;
  rubroOptionsCollection: IOptionsNgSelect[];
  dialogCommerce: MatDialogRef<DialogCommerceComponent>;
  id: any;

  constructor(
    private router: Router,
    private dialog: MatDialog,
    private ref: ChangeDetectorRef,
    private afipService: AfipService,
    private userService: UserService,
    private identity: IdentityService,
    private translateService: TranslateService,
    private notificationService: NotificationService
  ) {
    this.form = new UntypedFormGroup({
      comercioNombre: new UntypedFormControl('', Validators.compose([Validators.maxLength(255), Validators.required])),
      domicilioComercial: new UntypedFormControl(
        '',
        Validators.compose([Validators.maxLength(255), Validators.required])
      ),
      comercioRS: new UntypedFormControl('', Validators.compose([Validators.maxLength(255), Validators.required])),
      comercioCuit: new UntypedFormControl('', Validators.compose([Validators.maxLength(11), Validators.required])),
      domicilioFiscal: new UntypedFormControl('', Validators.compose([Validators.maxLength(255), Validators.required])),
      condicionIVA: new UntypedFormControl('', Validators.required),
      comercioRubro: new UntypedFormControl('', Validators.required),

      apiToken: new UntypedFormControl(''),
      departamentoPiso: new UntypedFormControl(''),
      departamentoNumero: new UntypedFormControl(''),
      rubro: new UntypedFormControl('', Validators.required)
    });

    this.registryState = <RegistryInformation>{};
    this.afipData = new AfipModel();
    this.rubroOptionsCollection = new Array<IOptionsNgSelect>();
  }

  get userHasOrganism(): boolean {
    return this.organism != null;
  }

  get organismId(): number | null {
    if (this.userHasOrganism) {
      return this.organism.id;
    }
    return null;
  }

  get serviceName(): string {
    let response = null;
    if (this.organism.servicioList) {
      let [service] = this.organism.servicioList;
      response = service.nombre;
    }
    return response;
  }

  get formControls() {
    return this.form.controls;
  }

  checkInvalidsForms(form: string) {
    if (form == 'cuit') {
      if (
        (this.form.get('comercioCuit').invalid && this.form.get('comercioCuit').dirty) ||
        this.displayCuitErrorMessage
      ) {
        return (this.isInvalidForm = true);
      }
    } else if (form == 'comercioNombre') {
      if (this.form.get('comercioNombre').invalid && this.form.get('comercioNombre').dirty) {
        return (this.isInvalidForm = true);
      }
    } else if (form == 'domicilioComercial') {
      if (this.form.get('domicilioComercial').invalid) {
        return (this.isInvalidForm = true);
      }
    }
    return (this.isInvalidForm = false);
  }

  invalidCuit() {
    if (
      (this.form.get('comercioCuit').invalid && this.form.get('comercioCuit').dirty) ||
      this.displayCuitErrorMessage
    ) {
      setTimeout((x) => {
        this.checkInvalidsForms('cuit');
      }, 300);
      return true;
    }
    return false;
  }

  invalidComercioNombre() {
    if (this.form.get('comercioNombre').invalid && this.form.get('comercioNombre').dirty) {
      setTimeout((x) => {
        this.checkInvalidsForms('comercioNombre');
      }, 300);
      return true;
    }
    return false;
  }
  isValidate: boolean = false;
  async ngOnInit() {
    this.form.get('domicilioComercial').valueChanges.subscribe((val) => {
      if (val == '' || ' ') {
        setTimeout((x) => {
          this.checkInvalidsForms('domicilioComercial');
        }, 300);
      }
    });
    this.isValidate = this.identity.getUserValidity();
    this.identity.currentUser.subscribe((user) => (this.currentUser = user));
    this.currentUser = this.userService.getCurrentUser();
    this.defineRegistryState();

    let optionsCollection = await this.userService.getMasterActivities();
    for (var option of optionsCollection) {
      this.rubroOptionsCollection.push(<IOptionsNgSelect>{
        value: option.id,
        display: option.nombre
      });
    }
    // this.id = this.userService.getPersonaInfo();
    try {
      const response = await this.userService.getCommerceByUserId();
      if (response) {
        this.organism = response;
        this.locationData = Object.assign({}, response.ubicacion);
      } else {
        this.organism = null;
      }
    } catch (error) {
      this.organism = null;
    }
    if (this.currentUser.organismo) {
      this.checked = true;
      this.wantToBeOrganismo = true;
      const token = await this.userService.getTokenCommerce();
      if (token) {
        this.hasApiToken = true;
        this.valueToken = token;
        if (this.valueToken.length / 60 > 1) {
          this.rowTxt += this.valueToken.length / 60;
        }
      }
    }

    setTimeout(() => {
      this.loadFormData();
    }, 500);
  }

  getStatusButton() {
    return !(this.form.valid && this.checked);
  }

  isResponsible() {
    return this.currentUser.isResponsible;
  }

  changeStatusCheck() {
    this.checked = !this.checked;
  }

  selectedPlaceEventHandler(place: GenericPlace | null): void {
    if (place) {
      this.form.get(this.DOMICILIO_COMERCIAL).setValue(place.nombreDireccion);
    } else {
      this.form.get(this.DOMICILIO_COMERCIAL).reset();
    }
    this.ref.detectChanges();
  }

  private getCondicionIVALabel(code: string): string {
    switch (code) {
      case 'EXENTO':
        return 'Exento';
      case 'MONOTRIBUTISTA':
        return 'Monotributista';
      case 'RESP_INSCRIPTO':
        return 'Responsable Inscripto';
      default:
        return 'Consultando en AFIP...';
    }
  }

  addToForm(input: string, value: any): void {
    this.form.get(input).setValue(value);
  }

  loadFormData(initialData: boolean = true): void {
    if (!initialData) {
      this.currentUser = this.userService.getCurrentUser();
    }

    if (this.userHasOrganism) {
      this.addToForm('comercioNombre', this.organism.nombre);
      this.addToForm('domicilioComercial', this.locationData.nombreDireccion);
      this.addToForm('comercioRS', this.organism.razonSocial);
      this.addToForm('comercioCuit', this.organism.numeroDocumento);
      this.addToForm('domicilioFiscal', this.organism.domicilioFiscal);
      this.addToForm('comercioRubro', this.serviceName);
      this.addToForm('apiToken', this.valueToken);
      this.addToForm('departamentoPiso', this.locationData.piso);
      this.addToForm('departamentoNumero', this.locationData.departamento);
      this.addToForm('condicionIVA', this.getCondicionIVALabel(this.organism.condicionIVA));
      this.ocult = true;
      if (this.form.get('departamentoPiso').value && this.form.get('departamentoNumero').value) {
        this.esDepartamento = true;
        this.selectHomeType = this.TIPO_DEPARTAMENTO;
      }
      if (this.organism.rubro) {
        this.addToForm('rubro', this.organism.rubro.id);
      }
      this.cuitReadonly = true;
    }
  }

  defineRegistryState(): void {
    let result = <RegistryInformation>{};
    if (this.currentUser.organismo && this.currentUser.organismo.rubro) {
      result.colorClass = 'color_green';
      result.icon = 'check_circle_outline';
      result.text = this.translate('pages.profile.messages.reg_complete');
    } else {
      result.colorClass = 'color_red';
      result.icon = 'cancel';
      result.text = this.translate('pages.profile.messages.reg_incomplete');
    }

    this.registryState = result;
  }

  async createAndSaveOrganism(form) {
    this.saving = true;
    if (this.form.valid) {
      let id: number = this.organismId;
      if (this.searchPlace.isPresent() && this.searchPlace.get() != null) {
        this.locationData = this.searchPlace.get();
        if (this.organism != null && this.organism.ubicacion != null) {
          this.locationData.id = this.organism.ubicacion.id;
        }
      }
      this.locationData.esDepartamento = true;

      if (form.departamentoPiso !== '' && form.departamentoNumero !== '') {
        this.locationData.esDepartamento = true;
        this.locationData.departamento = form.departamentoNumero;
        this.locationData.piso = form.departamentoPiso;
      } else {
        this.locationData.esDepartamento = false;
        form.departamentoPiso = '';
        form.departamentoNumero = '';
        this.locationData.departamento = null;
        this.locationData.piso = null;
      }

      this.locationData.descripcion = form.descipcionOptional;

      try {
        const response = await this.userService.saveOrganismsProfile(
          id,
          form.comercioNombre,
          form.comercioRS,
          form.domicilioFiscal,
          form.bancoForm != null ? form.bancoForm : '',
          form.comercioCuit,
          null,
          form.comercioRubro,
          this.afipData,
          this.locationData,
          +form.rubro
        );
        if (response) {
          this.organism = response;
          this.loadFormData(false);
        }
        this.form.markAsPristine();
        this.currentUser.organismo = this.organism;
        this.identity.saveUser(this.currentUser);
        this.defineRegistryState();
        this.notificationService.showSuccess(this.translate('pages.profile.messages.update_success'));
        setTimeout((x) => {
          this.navigate('/user/my-commerce');
        }, 300);
      } catch (error) {
        this.notificationService.showError(error.message);
        this.saving = false;
      }
    }
    this.saving = false;
  }

  async openDialogAndSave(form) {
    if (!this.userHasOrganism) {
      this.dialogCommerce = this.dialog.open(DialogCommerceComponent, {
        data: {
          confirmation: true
        }
      });
      this.dialogCommerce.afterClosed().subscribe(async (result) => {
        if (result) {
          this.saving = true;
          await this.createAndSaveOrganism(form);
          this.saving = false;
        }
      });
    } else {
      this.saving = true;
      await this.createAndSaveOrganism(form);
      this.saving = false;
    }
  }

  async onSubmitHandler(form: CommerceForm): Promise<void> {
    try {
      this.openDialogAndSave(form);
    } catch (error) {
      this.dialog.open(DialogAfipComponent, {
        width: '600px',
        data: {
          error: finalDotVerificator(error.message),
          title: this.translate('commons.labels.atention')
        }
      });
    }
  }

  cuitFormatter(cuit: string) {
    let first = cuit.substring(0, 2);
    let dni = cuit.substring(3, 11);
    let end = cuit.substring(12, 13);
    return `${first}${dni}${end}`;
  }

  searchingCuit: boolean = false;
  displayCuitErrorMessage: boolean = false;

  hideCuitErrors(): void {
    this.formControls.comercioCuit.setErrors({});
    this.formControls.comercioCuit.updateValueAndValidity();
  }

  resetControl(control: string): void {
    this.form.get(control).reset();
  }

  cleanAfipFields(buttonPressed: boolean = false): void {
    buttonPressed ? this.form.controls['comercioCuit'].reset() : null;
    this.resetControl('comercioRS');
    this.resetControl('domicilioFiscal');
    this.resetControl('comercioRubro');
  }

  async cuitInputEventHandler(value: string): Promise<void> {
    let cuit = this.cuitFormatter(value);
    if (cuit.length == 11) {
      if (validateCuit(cuit)) {
        this.searchingCuit = true;
        this.cuitReadonly = true;
        try {
          const afipResponse = await this.afipService.validateCuit(cuit);
          this.addToForm('comercioRS', afipResponse.razonSocial);
          this.addToForm('domicilioFiscal', afipResponse.domicilioFiscal);
          this.addToForm('comercioRubro', afipResponse.actividad);
          this.addToForm('condicionIVA', this.getCondicionIVALabel(''));

          this.afipData = afipResponse;

          this.hideCuitErrors();
        } catch (errorAfip) {
          this.dialog.open(DialogAfipComponent, {
            width: '600px',
            data: {
              error: finalDotVerificator(errorAfip),
              title: this.translate('pages.profile.messages.errors.cuit_validation')
            }
          });
        }
        this.searchingCuit = false;

        if (!this.userHasOrganism) {
          this.cuitReadonly = false;
        }
      } else {
        this.displayCuitErrorMessage = true;
        this.formControls.comercioCuit.setErrors({ incorrect: true });
      }
    } else {
      this.displayCuitErrorMessage = false;
      this.cleanAfipFields();
      this.hideCuitErrors();
    }
  }

  trimValue(value: string, controler: any) {
    value = value.trim();
    if (value == '') {
      controler.setValue(null);
    }
  }

  translate(key: string, paramKey?: string): string {
    let param;
    if (paramKey) {
      param = { campo: this.translateService.instant(paramKey) };
    }
    return this.translateService.instant(key, param);
  }

  navigate(url: string) {
    this.router.navigate([url]);
  }
}

interface RegistryInformation {
  icon: string;
  colorClass: string;
  text: string;
}
